import React from 'react';
import { useStrapi } from '../hooks/useStrapi';
import { getPackagePrices } from '../services/strapi';
import PricingCard from '../components/PricingCard';

const FALLBACK = [
  { attributes: { name: 'Starter', monthlyPrice: 999, onboardingPrice: 9999, currency: 'DKK', features: ['Basis compliance-overvågning', 'Op til 10 brugere', 'Email support', 'Månedlig rapportering', 'Grundlæggende risikovurdering'], ctaText: 'Kom i gang', ctaUrl: '/kontakt?pakke=starter' } },
  { attributes: { name: 'Professional', monthlyPrice: 2499, onboardingPrice: 19999, currency: 'DKK', isPopular: true, features: ['Alt fra Starter', 'Op til 50 brugere', 'Prioriteret support', 'Ugentlig rapportering', 'Avanceret risikovurdering', 'NIS2 compliance modul', 'Dokumenthåndtering'], ctaText: 'Vælg Professional', ctaUrl: '/kontakt?pakke=professional' } },
  { attributes: { name: 'Enterprise SMV', monthlyPrice: 5999, onboardingPrice: 39999, currency: 'DKK', features: ['Alt fra Professional', 'Ubegrænsede brugere', 'Dedikeret account manager', '24/7 support', 'Daglig rapportering', 'Fuld ISO 27001 understøttelse', 'Custom integrationer', 'On-site workshops'], ctaText: 'Kontakt os', ctaUrl: '/kontakt?pakke=enterprise' } },
];

export default function PricingPage() {
  const { data, loading, error } = useStrapi(getPackagePrices);
  // useStrapi already unwraps result.data, so data is the array directly
  const prices = data || FALLBACK;

  return (
    <>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h1 className="hero__title" style={{ fontSize: '2.2rem' }}>Priser & Pakker</h1>
          <p className="hero__subtitle">Vælg den pakke der passer til din virksomheds behov</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading && <div className="loading">Indlæser priser...</div>}
          {error && <div className="error">Kunne ikke hente data fra CMS. Viser standardpriser.</div>}
          <div className="pricing">
            {prices.map((pkg, i) => (
              <PricingCard key={pkg.id || i} pkg={pkg} />
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem', padding: '2rem', background: '#fff', borderRadius: '12px', border: '1px solid var(--color-border)' }}>
            <h3 style={{ marginBottom: '0.5rem', color: 'var(--color-primary)' }}>Alle priser er ekskl. moms</h3>
            <p style={{ color: 'var(--color-text-light)' }}>
              Kontakt os for en uforpligtende snak om hvilken pakke der passer til jeres virksomhed.
            </p>
            <a href="/kontakt" className="btn btn--primary" style={{ marginTop: '1rem' }}>Kontakt os</a>
          </div>
        </div>
      </section>
    </>
  );
}
